export const vi = {
  title: "Công cụ chuyển đổi kiểu chữ",
  placeholder: "Nhập văn bản của bạn tại đây...",
  uppercase: "CHỮ IN HOA",
  lowercase: "chữ thường",
  titleCase: "Kiểu Tiêu Đề",
  sentenceCase: "Kiểu câu",
  camelCase: "kiểuLạcĐà",
  snakeCase: "kiểu_rắn",
  reverseText: "Đảo văn bản",
  clearText: "Xóa văn bản",
  copySuccess: "Đã sao chép văn bản vào bộ nhớ tạm!",
  copyError: "Lỗi: Không có văn bản để sao chép!",
  words: "Số từ",
  characters: "Số ký tự",
  charactersNoSpaces: "Số ký tự (không tính khoảng trắng)",
  copyButton: "Sao chép vào bộ nhớ tạm",
  language: "Ngôn ngữ",
  english: "Tiếng Anh",
  vietnamese: "Tiếng Việt",
};
